export default __webpack_public_path__ + "static/media/ROYALCROMER_2020_COVER.852ab5fa.jpg";